/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ISHONCH Platform API
 * Login: POST /api/v1/auth/otp → code (dev: in the app log) → POST /api/v1/auth/otp/verify → paste response_data.as_access_token into Authorize. Every response is the company envelope (ADR-0007).
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { FavoriteIdsResponse, FavoriteProductResponse } from "../iSHONCHPlatformAPI.schemas";

import { httpRequest } from "../../http";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getMyFavoritesUrl = () => {
  return `/api/v1/cabinet/favorites`;
};

export const myFavorites = async (
  options?: Parameters<typeof httpRequest>[1],
): Promise<FavoriteProductResponse[]> => {
  return httpRequest<FavoriteProductResponse[]>(getMyFavoritesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getMyFavoritesQueryKey = () => {
  return [`/api/v1/cabinet/favorites`] as const;
};

export const getMyFavoritesQueryOptions = <
  TData = Awaited<ReturnType<typeof myFavorites>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof myFavorites>>, TError, TData>>;
  request?: SecondParameter<typeof httpRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMyFavoritesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof myFavorites>>> = ({ signal }) =>
    myFavorites({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof myFavorites>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MyFavoritesQueryResult = NonNullable<Awaited<ReturnType<typeof myFavorites>>>;
export type MyFavoritesQueryError = unknown;

export function useMyFavorites<TData = Awaited<ReturnType<typeof myFavorites>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof myFavorites>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof myFavorites>>,
          TError,
          Awaited<ReturnType<typeof myFavorites>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMyFavorites<TData = Awaited<ReturnType<typeof myFavorites>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof myFavorites>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof myFavorites>>,
          TError,
          Awaited<ReturnType<typeof myFavorites>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMyFavorites<TData = Awaited<ReturnType<typeof myFavorites>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof myFavorites>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useMyFavorites<TData = Awaited<ReturnType<typeof myFavorites>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof myFavorites>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMyFavoritesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getFavoriteIdsUrl = () => {
  return `/api/v1/cabinet/favorites/ids`;
};

export const favoriteIds = async (
  options?: Parameters<typeof httpRequest>[1],
): Promise<FavoriteIdsResponse> => {
  return httpRequest<FavoriteIdsResponse>(getFavoriteIdsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getFavoriteIdsQueryKey = () => {
  return [`/api/v1/cabinet/favorites/ids`] as const;
};

export const getFavoriteIdsQueryOptions = <
  TData = Awaited<ReturnType<typeof favoriteIds>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof favoriteIds>>, TError, TData>>;
  request?: SecondParameter<typeof httpRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFavoriteIdsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof favoriteIds>>> = ({ signal }) =>
    favoriteIds({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof favoriteIds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FavoriteIdsQueryResult = NonNullable<Awaited<ReturnType<typeof favoriteIds>>>;
export type FavoriteIdsQueryError = unknown;

export function useFavoriteIds<TData = Awaited<ReturnType<typeof favoriteIds>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof favoriteIds>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof favoriteIds>>,
          TError,
          Awaited<ReturnType<typeof favoriteIds>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFavoriteIds<TData = Awaited<ReturnType<typeof favoriteIds>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof favoriteIds>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof favoriteIds>>,
          TError,
          Awaited<ReturnType<typeof favoriteIds>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFavoriteIds<TData = Awaited<ReturnType<typeof favoriteIds>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof favoriteIds>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useFavoriteIds<TData = Awaited<ReturnType<typeof favoriteIds>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof favoriteIds>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFavoriteIdsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRemoveFavoriteUrl = (productId: string) => {
  return `/api/v1/cabinet/favorites/${productId}`;
};

export const removeFavorite = async (
  productId: string,
  options?: Parameters<typeof httpRequest>[1],
): Promise<null> => {
  return httpRequest<null>(getRemoveFavoriteUrl(productId), {
    ...options,
    method: "DELETE",
  });
};

export const getRemoveFavoriteMutationKey = () => ["removeFavorite"] as const;

export const getRemoveFavoriteMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeFavorite>>,
    TError,
    RemoveFavoriteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeFavorite>>,
  TError,
  RemoveFavoriteMutationVariables,
  TContext
> => {
  const mutationKey = getRemoveFavoriteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeFavorite>>,
    RemoveFavoriteMutationVariables
  > = (props) => {
    const { productId } = props ?? {};

    return removeFavorite(productId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveFavoriteMutationResult = NonNullable<Awaited<ReturnType<typeof removeFavorite>>>;

export type RemoveFavoriteMutationError = unknown;
export type RemoveFavoriteMutationVariables = { productId: string };

export const useRemoveFavorite = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeFavorite>>,
      TError,
      RemoveFavoriteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeFavorite>>,
  TError,
  RemoveFavoriteMutationVariables,
  TContext
> => {
  return useMutation(getRemoveFavoriteMutationOptions(options), queryClient);
};
export const getAddFavoriteUrl = (productId: string) => {
  return `/api/v1/cabinet/favorites/${productId}`;
};

export const addFavorite = async (
  productId: string,
  options?: Parameters<typeof httpRequest>[1],
): Promise<null> => {
  return httpRequest<null>(getAddFavoriteUrl(productId), {
    ...options,
    method: "PUT",
  });
};

export const getAddFavoriteMutationKey = () => ["addFavorite"] as const;

export const getAddFavoriteMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addFavorite>>,
    TError,
    AddFavoriteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addFavorite>>,
  TError,
  AddFavoriteMutationVariables,
  TContext
> => {
  const mutationKey = getAddFavoriteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addFavorite>>,
    AddFavoriteMutationVariables
  > = (props) => {
    const { productId } = props ?? {};

    return addFavorite(productId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddFavoriteMutationResult = NonNullable<Awaited<ReturnType<typeof addFavorite>>>;

export type AddFavoriteMutationError = unknown;
export type AddFavoriteMutationVariables = { productId: string };

export const useAddFavorite = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addFavorite>>,
      TError,
      AddFavoriteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addFavorite>>,
  TError,
  AddFavoriteMutationVariables,
  TContext
> => {
  return useMutation(getAddFavoriteMutationOptions(options), queryClient);
};
